import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const FitMapIcon = ({ className }) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" className={className}>
    <path d="M2.9532 17.9163L2.08301 17.0461L7.87951 11.2496H3.74967V9.99966H9.99965V16.2496H8.74968V12.1198L2.9532 17.9163ZM9.99965 9.99966V3.74967H11.2496V7.87951L17.0461 2.08301L17.9163 2.9532L12.1198 8.74968H16.2496V9.99966H9.99965Z" fill="#333945"/>
  </SvgIcon>
);

export default FitMapIcon;
